export default __webpack_public_path__ + "static/media/sneak.e33aac12.gif";